<template>
  <div class="card">
    <v-cardheader :text="title">
      <slot name="header" />
    </v-cardheader>
    <v-cardbody :padded="padded">
      <slot />
    </v-cardbody>
  </div>
</template>

<script>
import CardHeader from "@/atoms/CardHeader";
import CardBody from "@/atoms/CardBody";
export default {
	components: {
		"v-cardheader": CardHeader,
		"v-cardbody": CardBody
	},
	props: {
		title: {
			type: String,
			default: null
		},
      padded: {
        type: Boolean,
        default: true
      }
	}
};
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
	.card {
		display: flex;
    flex: 1;
		flex-direction: column;
		margin-bottom: 1rem;
	}
</style>
